module.exports = __webpack_public_path__ + "img/pinterest-source.8f7332a5.svg";